<script>
export default {
  name: "ArticleMeaningExample",
  props: {
    example: {
      type: String,
      required: true
    }
  }
};
</script>

<template>
  <div v-if="example" class="article-content__politiken-grid">
    <div class="article-content__text article-content__politiken-grid-label">
      {{ $t("article.polCurrentDada.example") }}
    </div>
    <div
      class="article-content__text--light article-content__text--italic article-content__politiken-grid-content"
      v-html="example"
    ></div>
  </div>
</template>
